// src/components/Login.js
import React, { useState } from 'react'
import './HomePageCSS.css'
import { Button, Modal, message,Form  } from 'antd'
import RegisterForm from './RegistrationForm'
import LoginForm from './LoginForm'
import Slider from 'react-slick'
import slideImg1 from '../assets/1.jpg'
import slideImg2 from '../assets/2.jpeg'
import slideImg3 from '../assets/3.jpeg'
import FooterPage from './FooterPage'

const HomePage = () => {

  const [messageApi, contextHolder] = message.useMessage();
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [isRegisterOpen, setIsRegisterOpen] = useState(false)
  const [form] = Form.useForm();

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: false,
  }

  const slides = [
    {
      image: slideImg1,
      text: 'MANIKBAG DIGAMBAR JAIN BOARDING',
    },
    {
      image: slideImg2,
      text: 'MANIKBAG DIGAMBAR JAIN BOARDING',
    },
    {
      image: slideImg3,
      text: 'MANIKBAG DIGAMBAR JAIN BOARDING',
    },
  ]


  return (
    <div className="login-page">
      <div className="top-bar">
        <span className="phone px-2">📞 +91 1234567890</span>
      </div>

     <div className="top-bar1">
        <Button className="top-btn shadow" onClick={() => setIsLoginOpen(true)}>
          Log In
        </Button>
        <Button className="top-btn shadow"  onClick={() => setIsRegisterOpen(true)}>
          Register
        </Button>
      </div>


      <div className="image-slider-wrapper">

          <div className="slide-overlay">
            <h2>MANIKBAG DIGAMBAR JAIN BOARDING</h2>
            <p className="pt-2">19TH JAIN VADHU VAR PARICHAYA MELAVA</p>
            <Button className="slide-register-btn shadow" onClick={() => setIsRegisterOpen(true)}>
              Register Now
            </Button>
          </div>

          <Slider {...sliderSettings}>
            {slides.map((slide, index) => (
              <div key={index} className="slide-background-container">
                <img src={slide.image} alt={`slide-${index}`} className="slide-image" />
              </div>
            ))}
          </Slider>

      </div>

      <div className="row marquee m-0 p-0 mb-2">
        <marquee  scrollamount="7" className="pt-2" style={{backgroundColor: "black",}}
          >
            <h5 className="fw-bolder" style={{color:"white"}}>
              REGISTRATION FOR 19TH JAIN VADHU VAR PARICHAYA MELAVA IS OPEN ...!
            </h5>
          </marquee>
      </div>

{/* =====Member Login==== */}
       <Modal
         title={
          <div className="custom-modal-title">
            Member Login
          </div>
        }
        open={isLoginOpen}
        onCancel={() => setIsLoginOpen(false)}
        footer={null}
        centered
      >
        <LoginForm />
      </Modal>

{/* =====Member Registration==== */}
      <Modal
        title={
          <div className="custom-modal-title">
            Register New Account
          </div>
        }
        open={isRegisterOpen}
        onCancel={() => setIsRegisterOpen(false)}
        footer={null}
        centered 
         width={800} // Large on desktop
         className="responsive-modal" // Custom class for responsive behavior
      >
        {/* <RegisterForm /> */}
        <RegisterForm
          form={form}
          closeModal={() => setIsRegisterOpen(false)}
        />
      </Modal>

      <FooterPage/>

    </div>
  )
}

export default HomePage
